/*
 * cert-modal
 * ------------------------------------------------------------------
 * Certifications image modal for the Alberobello "double card" section.
 * Extends Dawn's ModalDialog (assets/global.js) so open/close, ESC key,
 * focus trap and body scroll-lock are reused — same approach as
 * assets/product-modal.js. Clicking the image toggles a true-fullscreen
 * (100%) state; closing the modal resets it.
 */
if (typeof ModalDialog !== 'undefined') {
  customElements.get('cert-modal') ||
    customElements.define(
      'cert-modal',
      class extends ModalDialog {
        constructor() {
          super();
          const image = this.querySelector('.alberobello-cert-modal__image');
          if (image) {
            image.addEventListener('click', () => {
              this.classList.toggle('is-fullscreen');
            });
          }
        }

        hide() {
          this.classList.remove('is-fullscreen');
          super.hide();
        }
      }
    );
}
